import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'deal-tabular-pipeline-dates',
    templateUrl: './tabular-pipeline-dates.component.html',
    styleUrls: ['./tabular-pipeline-dates.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabularPipelineDatesComponent implements OnInit{
  @Input() status_and_dates: any;
  @Input() permissions: any;

  ngOnInit() {
  }
}
